var map = {
	"./avatar-action-0001.svg": 721,
	"./avatar-action-0002.svg": 722,
	"./avatar-action-0003.svg": 723,
	"./avatar-action-0004.svg": 724,
	"./avatar-action-0005.svg": 725,
	"./avatar-action-0006.svg": 726,
	"./avatar-action-0007.svg": 727,
	"./avatar-action-0008.svg": 728,
	"./avatar-action-0009.svg": 729,
	"./avatar-action-0010.svg": 730,
	"./avatar-action-0011.svg": 731,
	"./avatar-action-0012.svg": 732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 720;